<template>
    <div class="services">
        <section class="page">
            <header class="main">
                <div class="container">
                    <h4>Services</h4>
                </div>
            </header>
            <img src="/h1-subpage-1.jpg" alt="">
            <div class="page-content">
                <div class="container">
                <h1>Some services</h1>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: "services",
  components: {}
};
</script>
<style lang="scss">
section.page {
  header {
    height: 150px;
    background-color: #0c0c0c;
    display: flex;
    // padding: 0 4rem;
    align-items: center;
  }
  .page-content {
      padding: 125px 0;
  }
}
</style>
